import { useQuery } from '@tanstack/react-query';
import getModalities from '../api/getModalities';

const QUERY_KEY = 'modalities';

const useModalities = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => getModalities(),
    staleTime: 1000 * 60 * 60 * 12, // 12 hours
    cacheTime: 1000 * 60 * 60 * 12.5, // 12.5 hours
  });

  return { ...rest, modalities: data };
};

export default useModalities;
